import { render, staticRenderFns } from "./Efficiency.vue?vue&type=template&id=dbee012c&scoped=true"
import script from "./Efficiency.vue?vue&type=script&lang=js"
export * from "./Efficiency.vue?vue&type=script&lang=js"
import style0 from "./Efficiency.vue?vue&type=style&index=0&id=dbee012c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbee012c",
  null
  
)

export default component.exports